import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=5532c246&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5532c246')) {
      api.createRecord('5532c246', component.options)
    } else {
      api.reload('5532c246', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=5532c246&", function () {
      api.rerender('5532c246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/layout/Navbar.vue"
export default component.exports